import store from '@/store'

function checkPermission(el, binding, vnode) {
  // console.log(el, binding, vnode, "指令参数");
  //vnode.context就相当于当前组件的this
  //非子账号，都可访问
  if (localStorage.USER_AUTH == "true") { return }
  const { value } = binding;
  //获取权限列表
  const permissionList = store.state && store.state.pagePermissionList;
  // console.log(permissionList,"permissionList--");
  //获取当前页面的id
  const elVal = vnode.context.$route.meta.id;
  // meta.id
  const permissionId = elVal instanceof String && [elVal] || elVal;
  // 如果没有配置菜单权限，则都视作有权限处理
  if (!permissionId) {
    return
  }
  // 此处的权限列表判断为或关系，也就是v-permission的参数中的权限有一个满足，就将显示该元素
  if (value && value instanceof Array && value.length > 0) {
    // 当前允许的权限列表
    const actions = value
    //some用于检测数组中的元素是否满足指定条件
    const hasPermission = permissionList.some(p => {
      //如果权限id不包含在里面
      if (!permissionId.includes(p.id)) {
        return false
      }
      //如果操作数组中没有数据，按钮全部隐藏
      if (!p.actionList || p.actionList.length === 0) {
        return false
      }
      let hasAction = false
      //操作数组中有数据
      for (let i = 0; i < actions.length; i++) {
        const actionName = actions[i]
        //操作数组中包含当前权限返回true
        if (p.actionList.includes(actionName)) {
          hasAction = true
          break
        }
      }
      return hasAction
    });
    if (!hasPermission) {
      //找到父节点，删除节点
      el.parentNode && el.parentNode.removeChild(el)
    }
  } else {
    throw new Error(`need roles! Like v-permission="['admin','editor']"`)
  }
}

export default {
  inserted(el, binding, vnode) {
    checkPermission(el, binding, vnode)
  },
}
